<template>
    <div>
        Services
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    }
}

</script>



// WEBPACK FOOTER //
// src/views/portfolio/Content/Service.vue